import { FormElementsActionTypes } from '../actions/formElementsActions';
import { FORM_FIELD_TYPE_CODE } from '../../constants/formElements';
import ACTIONS_TYPES from '../../constants/types';

export type IFormElementsState = Dict<FORM_FIELD_TYPE_CODE>;

const initialState: IFormElementsState = {};

export default function (state = initialState, action: FormElementsActionTypes) {
  switch (action.type) {
    case ACTIONS_TYPES.SET_FORM_ELEMENTS:
      return { ...state, ...action.payload };

    default:
      return state;
  }
}
